export const REQUEST_COMPOSE_ACTION  = 'request_compose_action'
export const COMPOSE_ACTION_SUCCESS = 'compose_action_success'
export const COMPOSE_ACTION_FAILURE = 'compose_action_failure'

export const CLEAR_COMPOSE_ACTION_STATES = 'clear_compose_action_states'